import { AfterViewInit, Directive, OnDestroy, Self } from '@angular/core';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';

@Directive({
  selector: 'ng2-pdfjs-viewer[kodit-pdf-native-print]',
})
export class PdfNativePrintDirective implements AfterViewInit, OnDestroy {
  private _viewerIframe: HTMLIFrameElement;
  private _printIframe?: HTMLIFrameElement;
  private _printUrl?: string;
  private readonly _onViewerLoad = () => this._overrideViewerPrint();

  constructor(@Self() private _viewer: PdfJsViewerComponent) {}

  ngAfterViewInit(): void {
    this._viewerIframe = this._viewer.iframe.nativeElement;
    this._viewerIframe.addEventListener('load', this._onViewerLoad);
    this._overrideViewerPrint();
  }

  ngOnDestroy(): void {
    this._viewerIframe?.removeEventListener('load', this._onViewerLoad);
    this._cleanup();
  }

  private _overrideViewerPrint() {
    const viewerWindow = this._viewerIframe.contentWindow as any;
    if (!viewerWindow?.PDFViewerApplication) {
      return;
    }

    viewerWindow.print = () => this._printOriginal(viewerWindow);
  }

  private _printOriginal(viewerWindow: any) {
    const pdfDocument = viewerWindow.PDFViewerApplication?.pdfDocument;
    if (!pdfDocument) {
      return;
    }

    const safariWindow = this._isSafari ? window.open('', '_blank') : null;

    pdfDocument.getData().then((data: Uint8Array) => {
      this._cleanup();
      this._printUrl = URL.createObjectURL(
        new Blob([data], { type: 'application/pdf' })
      );

      if (safariWindow) {
        safariWindow.location.href = this._printUrl;
        return;
      }

      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.right = '0';
      iframe.style.bottom = '0';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = '0';
      iframe.onload = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      };
      iframe.src = this._printUrl;
      document.body.appendChild(iframe);
      this._printIframe = iframe;
    });
  }

  private _cleanup() {
    this._printIframe?.remove();
    this._printIframe = undefined;

    if (this._printUrl) {
      URL.revokeObjectURL(this._printUrl);
      this._printUrl = undefined;
    }
  }

  private get _isSafari(): boolean {
    return /^((?!chrome|chromium|android|crios|fxios|edg).)*safari/i.test(
      navigator.userAgent
    );
  }
}
